
<v-dialog
    v-model="touched"
    max-width="480"
>
    <template #activator="{ on, attrs }">
        <slot v-bind="{ on, attrs }"></slot>
    </template>

    <v-card>
        <v-card-title class="customized-primary white--text">
            ID: {{ value.id }} / {{ t('workout_label_id') }}: {{ value.workoutId }}
        </v-card-title>

        <v-card-text class="pb-0">
            <v-form class="mt-6">
                <v-text-field
                    v-model="value.totalDistance"
                    type="text"
                    :label="t('workouts_label_distance')"
                    required
                    outlined
                    dense
                    :error-messages="form.errors.get('distance')"
                ></v-text-field>
                <v-text-field
                    v-model="value.totalDuration"
                    type="text"
                    :label="t('workouts_label_duration')"
                    required
                    outlined
                    dense
                    :error-messages="form.errors.get('duration')"
                ></v-text-field>
            </v-form>
        </v-card-text>

        <v-card-actions>
            <v-btn
                color="primary"
                @click="submit"
                width="45%"
                dark
            >{{ t('general_action_update') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
                color="orange"
                @click="touched = false"
                width="45%"
                dark
            >{{ t('general_action_cancel') }}</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
